import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

// Claim a bonus
export const bonus = createAsyncThunk(
  "bonus/getBonus",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("/gift/claim-bonus", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

// Get bonus list
export const getBonusList = createAsyncThunk(
  "bonus/getBonusList",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("/bonus/get-all-bonus", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const bonusSlice = createSlice({
  name: "bonus",
  initialState: {
    claimBonus: {
      data: null,
      loading: false,
      error: null,
    },
    listBonuses: {
      data: [],
      loading: false,
      error: null,
      pagination: null,
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(bonus.pending, (state) => {
        state.claimBonus.loading = true;
        state.claimBonus.error = null;
      })
      .addCase(bonus.fulfilled, (state, action) => {
        state.claimBonus.loading = false;
        state.claimBonus.data = action.payload;
      })
      .addCase(bonus.rejected, (state, action) => {
        state.claimBonus.loading = false;
        state.claimBonus.error = action.payload;
      })

      .addCase(getBonusList.pending, (state) => {
        state.listBonuses.loading = true;
        state.listBonuses.error = null;
      })
      .addCase(getBonusList.fulfilled, (state, action) => {
        state.listBonuses.loading = false;
        state.listBonuses.data = action.payload.data || [];
        state.listBonuses.pagination = action.payload.pagination || null;
      })
      .addCase(getBonusList.rejected, (state, action) => {
        state.listBonuses.loading = false;
        state.listBonuses.error = action.payload;
      });
  },
});

export default bonusSlice.reducer;
